export class EmployeeDependents {
    dependantId: number;
    firstName: string;
    lastName: string;
    sex: string;
    dob: Date;
    dependant: string

}